module.exports = __webpack_public_path__ + "static/media/x_icon_clip_art_9385.e1ddcf6d.jpg";